<mat-dialog-content>
    <h1 mat-dialog-title>Details</h1>
    <mat-card-title class="attribute-type-header">Description</mat-card-title>
    <mat-card-content>
        <tiny-mce-comment-attribute [model]="this" [fieldName]="'description'">
        </tiny-mce-comment-attribute>
    </mat-card-content>
    <mat-card-title class="attribute-type-header">Links</mat-card-title>
    <mat-dialog-content *ngIf="links.length">
        <div class="links-container">
            <app-link-attribute-list [links]="links"></app-link-attribute-list>
        </div>
    </mat-dialog-content>
    <mat-dialog-content *ngIf="!links.length" class="no-links-content">
        No links
    </mat-dialog-content>
    <mat-card-title class="attribute-type-header">Assumption</mat-card-title>
    <mat-dialog-content>
        <mat-slide-toggle disabled="true" [ngModel]="isAssumptionEnabled">Assumption applied</mat-slide-toggle>
        <textarea disabled="true" class="text-field" [ngModel]="assumptionValue" cdkTextareaAutosize
            cdkAutosizeMinRows="3"></textarea>
    </mat-dialog-content>
</mat-dialog-content>